<template>
  <div class="wrp">
    <div class="invoice-update-wrp">
      <div class="margin-btm">
        <van-cell-group :border="false" class="border-btm">
          <van-field
            label="发票标签"
            @click="tagVisible = true"
          >
            <input slot="input" class="input" type="text" v-model="editData.tag" placeholder="请选择标签" readonly>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="备注"
          >
            <input slot="input" class="input" type="text" v-model="editData.customRemark" placeholder="请输入">
          </van-field>
        </van-cell-group>
      </div>
      <p class="tips">
        请确认发票信息是否与票面相符
      </p>

      <van-cell-group :border="false">
        <van-field
          label="票据类型"
        >
          <input slot="input" class="input" type="text" v-model="invoiceInfo.invoiceTypeName" placeholder="请选择发票类型" readonly>
        </van-field>
      </van-cell-group>

      <van-cell-group v-show="invoiceInfo.purchaserName">
        <van-field
          label="购方名称"
          v-model="editData.purchaserName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.sellerName">
        <van-field
          label="销方名称"
          v-model="editData.sellerName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.invoiceCode">
        <van-field
          label="发票代码"
          v-model="editData.invoiceCode"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          label="发票号码"
          v-model="editData.invoiceNo"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.passengerName">
        <van-field
          label="乘客姓名"
          v-model="editData.passengerName"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.mileage">
        <van-field
          label="里程"
          v-model="editData.mileage"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.getOnDate">
        <van-field
          label="乘车日期"
          v-model="editData.getOnDate"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.trainNumber">
        <van-field
          label="车次"
          v-model="editData.trainNumber"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.seat">
        <van-field
          label="座位类型"
          v-model="editData.seat"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.stationGetOn">
        <van-field
          label="上车车站"
          v-model="editData.stationGetOn"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.stationGetOff">
        <van-field
          label="下车车站"
          v-model="editData.stationGetOff"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.drewDate && invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11' || invoiceInfo.invoiceType === '202'">
        <van-field
          label="开票日期"
          v-model="editData.drewDate"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.amountWithTax">
        <van-field
          label="金额（含税）"
          v-model="editData.amountWithTax"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.fare">
        <van-field
          label="票价"
          v-model="editData.fare"
        />
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.totalTax">
        <van-field
          label="税费"
          v-model="editData.totalTax"
        />
      </van-cell-group>
      <van-cell-group
        v-show="invoiceInfo.amount"
      >
        <van-field
          label="不含税金额"
          v-model="editData.amount"
        />
      </van-cell-group>
      <van-cell-group
        v-show="invoiceInfo.checkCode"
      >
        <van-field
          :label="invoiceInfo.invoiceType === '202' ? '验证码' : '校验码'"
          v-model="editData.checkCode"
        />
      </van-cell-group>
    </div>
    <MyActionSheet
      :columns="invoiceList"
      :visible="invoiceVisible"
      @cancel="invoiceVisible = false"
      @confirm="onInvoiceTypeConfirm"
      type="invoiceType"
    />
    <MyActionSheet
      :columns="companyNameList"
      :visible="companyData.visible"
      @cancel="companyData.visible = false"
      @confirm="onCompanyConfirm"
      type="companyList"
    />
    <MyActionSheet
      :columns="tagList"
      :visible="tagVisible"
      @cancel="tagVisible = false"
      @confirm="onTagConfirm"
      type="tag"
    />
    <div class="btn-wrp">
      <van-button
        class="btn"
        round
        @click="goBack"
      >
        取消
      </van-button>
      <van-button
        class="btn"
        round
        @click="save"
      >
        保存
      </van-button>
    </div>
  </div>
</template>

<script>
import { CellGroup, Button, Toast, Notify, Popup, Icon, Field, Cell } from 'vant'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'
import { officialAccountRequest, accountRequest } from '@services'
import UploadService from '@services/UploadService'
import { deepCopy, isEmpty } from '@utils/basicUtil'
export default {
  data: () => ({
    invoiceInfo: {},
    invoiceType: '01',
    submitType: '',
    submitData: {
      officialAccountId: '',
      imagePath: ''
    },
    companyData: {
      visible: false,
      companyId: ''
    },
    editData: {},
    companyList: [],
    companyNameList: [],
    tagList: [
      { name: '餐费' },
      { name: '招待费' },
      { name: '差旅费' },
      { name: '通讯费' },
      { name: '交通费' }
    ],
    invoiceList: [
      {
        name: '增值税专用发票',
        id: '01'
      },
      {
        name: '增值税普通发票',
        id: '04'
      },
      {
        name: '增值税电子发票',
        id: '10'
      },
      {
        name: '增值税卷式发票',
        id: '11'
      },
      {
        name: '航空客票行程单',
        id: '202'
      },
      {
        name: '定额发票',
        id: '200'
      },
      {
        name: '火车票',
        id: '201'
      },
      {
        name: '出租车发票',
        id: '207'
      }
    ],
    invoiceVisible: false,
    tagVisible: false
  }),
  computed: {
    invoiceImageData: (vm) => {
      return vm.$store.state.invoice.invoiceImageData
    },
    userInfo: (vm) => {
      return vm.$store.state.user.company
    }
  },
  watch: {
    userInfo () {
      if (this.userInfo.id) {
        this.submitData.officialAccountId = this.userInfo.id
      }
    }
  },
  mounted () {
    this.discern()
  },
  methods: {
    async getCompanies () {
      const postData = {
        size: 9999
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        this.companyList = data.result
        let companyNameList = []
        this.companyList.forEach(item => {
          companyNameList.push({ name: item.companyName, id: item.id })
        })
        this.companyNameList = companyNameList
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async discern () {
      Toast.loading({
        message: '发票识别中...',
        forbidClick: true,
        duration: 0
      })
      this.invoiceInfo = {}
      const data = await officialAccountRequest.weChat.discern({ currentUserMobile: this.userInfo.mobile, imageData: this.invoiceImageData.base64, officialAccountId: this.submitData.officialAccountId })
      if (data.success) {
        if (data.result.vatFlag === '1') {
          this.nonVatTicket(data.result.nonVatTicketDiscern)
          this.invoiceType = 'nonVat'
        } else {
          this.vatTicket(data.result.vatTicketDiscern)
          this.invoiceType = 'vat'
        }
      } else {
        Notify({ type: 'danger', message: '发票识别出错' })
        this.goBack()
      }
      this.overlayVisible = true
      Toast.clear({
        clearAll: true
      })
    },
    uploadImage () {
      Toast.loading({
        message: '发票上传中...',
        forbidClick: true,
        duration: 0
      })
      return new Promise(async (resolve, reject) => {
        try {
          const data = await UploadService(this.invoiceImageData.file, '', true)
          if (data.success) {
            this.submitData.imagePath = data.fileUrl
            resolve()
          }
        } catch (e) {
          alert(e)
        }
      })
    },
    vatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '01':
          invoiceInfo.invoiceTypeName = '增值税专用发票'
          break
        case '04':
          invoiceInfo.invoiceTypeName = '增值税普通发票'
          break
        case '10':
          invoiceInfo.invoiceTypeName = '增值税电子发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    nonVatTicket (data) {
      let invoiceInfo = data
      switch (data.invoiceType) {
        case '202':
          invoiceInfo.invoiceTypeName = '航空客票行程单'
          break
        case '200':
          invoiceInfo.invoiceTypeName = '定额发票'
          break
        case '201':
          invoiceInfo.invoiceTypeName = '火车票'
          break
        case '207':
          invoiceInfo.invoiceTypeName = '出租车发票'
          break
        case '11':
          invoiceInfo.invoiceTypeName = '增值税卷式发票'
          break
        default:
          break
      }
      this.invoiceInfo = invoiceInfo
      this.editData = deepCopy(invoiceInfo)
    },
    submit () {
      this.submitType = 'saveAndCommit'
      this.saveAndCommit()
    },
    async save () {
      if (this.editData.customRemark && this.editData.customRemark.length > 32) {
        return Notify({ type: 'danger', message: '备注字段不能超过32个字符' })
      }
      if (!this.testField('tag') || !this.testField('invoiceTypeName') || !this.testField('purchaserName') || !this.testField('sellerName') || !this.testField('invoiceCode') || !this.testField('invoiceNo') || !this.testField('passengerName') || !this.testField('mileage') || !this.testField('getOnDate') || !this.testField('trainNumber') || !this.testField('seat') || !this.testField('stationGetOn') || !this.testField('stationGetOff') || !this.testField('drewDate') || !this.testField('amountWithTax') || !this.testField('fare') || !this.testField('totalTax') || !this.testField('amount') || !this.testField('checkCode')) {
        return
      }
      await this.uploadImage()
      this.submitType = 'save'
      if (this.invoiceType === 'nonVat') {
        this.nonVatSave()
      } else {
        this.vatSave()
      }
    },
    showCompanyPicker () {
      this.companyData.visible = true
    },
    onCompanyConfirm (data) {
      this.companyData.visible = false
      this.submitData.officialAccountId = data.value.id
      this.saveAndCommit()
    },
    onInvoiceTypeConfirm (data) {
      this.invoiceVisible = false
      this.invoiceInfo.invoiceType = data.value.id
      this.invoiceInfo.invoiceTypeName = data.value.name
    },
    onTagConfirm (data) {
      this.tagVisible = false
      this.editData.tag = data.value.name
    },
    findCompany (companyName) {
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].companyName === companyName) {
          return this.companyList[i]
        }
      }
    },
    async saveAndCommit () {
      await this.uploadImage()
      if (this.invoiceType === 'nonVat') {
        this.nonVatSaveAndCommit()
      } else {
        this.vatSaveAndCommit()
      }
    },
    async nonVatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.nonVatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async nonVatSave () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData }, ...{ mobileFlag: 1, invoiceSource: 5 } }
      const data = await officialAccountRequest.weChat.newNonVatSave(postData)
      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async vatSaveAndCommit () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData } }

      const data = await officialAccountRequest.weChat.vatSaveAndCommit(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    async vatSave () {
      let postData = { ...this.submitData, ticketInfo: { ...this.editData }, ...{ mobileFlag: 1, invoiceSource: 5 } }
      const data = await officialAccountRequest.weChat.newVatSave(postData)

      if (data.success) {
        this.closeLoading()
      } else {
        this.uploadError(data.message)
      }
    },
    testField (type) {
      const fieldObj = {
        tag: '标签',
        invoiceTypeName: '票据类型',
        purchaserName: '购方名称',
        sellerName: '销方名称',
        invoiceCode: '发票代码',
        invoiceNo: '发票号码',
        passengerName: '乘客姓名',
        mileage: '里程',
        getOnDate: '乘车日期',
        trainNumber: '车次',
        seat: '座位类型',
        stationGetOn: '上车车站',
        stationGetOff: '下车车站',
        drewDate: '开票日期',
        amountWithTax: '金额（含税）',
        fare: '票价',
        totalTax: '税费',
        amount: '不含税金额',
        checkCode: this.editData.invoiceType === '202' ? '验证码' : '校验码'
      }
      const requireMap = {
        tag: ['all'],
        invoiceTypeName: [],
        purchaserName: ['01', '04', '10', '11'],
        sellerName: ['01', '04', '10', '11'],
        invoiceCode: ['200', '207', '01', '04', '10', '11'],
        invoiceNo: ['200', '207', '01', '04', '10', '11', '202', '201'],
        passengerName: ['202', '201'],
        mileage: ['207'],
        getOnDate: ['201'],
        trainNumber: ['201'],
        seat: ['201'],
        stationGetOn: ['201'],
        stationGetOff: ['201'],
        drewDate: ['01', '04', '10', '11', '202'],
        amountWithTax: ['200', '207', '01', '04', '10', '11', '202', '201'],
        fare: ['202'],
        totalTax: [],
        amount: ['01', '04', '10'],
        checkCode: ['04', '10', '11', '202']
      }
      if (isEmpty(this.editData[type]) && (requireMap[type].includes('all') || requireMap[type].includes(this.editData.invoiceType))) {
        Notify({ type: 'danger', message: `${fieldObj[type]}不能为空` })
        return false
      }
      return true
    },
    uploadError (message) {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'danger', message: `收票失败！${message}` })
      this.goBack()
    },
    closeLoading () {
      Toast.clear({
        clearAll: true
      })
      Notify({ type: 'success', message: '收票成功！' })
      this.goBack()
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    MyActionSheet
  }
}
</script>

<style lang="less" scoped>
  .wrp {
    height: 100%;
    background-color: white;
  }
  /deep/.van-cell-group {
    box-sizing: border-box;
    padding: 4px 8px;
  }
  .tips {
    font-size: 24px;
    color: #999;
    margin: 10px 40px;
  }
  .border-btm {
    border-bottom: 1px solid #eff2f2;
  }
  .margin-btm {
    margin-bottom: 30px;
    border-bottom: 20px solid #eff2f2;
  }
  .input {
    font-size: 26px;
    font-family: "PingFang SC";
    font-weight: 500;
    width: 100%;
    text-align: right;
    border: none;
    margin: 0;
  }
  .larger-input {
    height: 200px;
  }
  /deep/.van-field__label {
    color: #333;
    width: 200px;
  }
  .invoice-update-wrp {
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 200px;
  }
  /deep/.van-field__control {
    text-align: right;
  }
  /deep/.btn.cancel {
    background: white;
  }
  .btn-wrp{
    display: flex;
    justify-content: space-evenly;
    padding: 40px 20px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    width: 100%;
    .btn{
      width: 330px;
      height: 90px;
      background: #D4D6DC;
      border-radius: 12px;
      color: #fff;
      font-size: 32px;
      font-weight: 500;
      text-align: center;
    }
    .btn:nth-child(2){
      background: #2372FF;
      color: #fff;
    }
  }
</style>
